import ColorSelector from './ColorSelector';

export default ColorSelector;
